<template lang="pug">
v-card
  v-card-title.primary--text.title-text(style="border-radius: 5px 5px 0px 0px", dense) {{ title }}
    v-spacer
    v-icon(color="primary") mdi-cash-multiple
  v-divider
  v-expansion-panels(dense)
    v-expansion-panel(
      v-for="account in listAccount",
      :key="account.accountNumber",
      dense
    )
      v-expansion-panel-header(dense) 
        v-layout(row)
          .caption.font-weight-bold.primary--text {{ account.accountNumber | accountformat }}
          .caption.font-weight-bold.secondary--text.ml-2 {{ '(' + account.accountTypeName + ')' }}
        template(v-slot:actions)
          v-icon(color="primary") mdi-chevron-down
      v-expansion-panel-content
        v-layout(
          row,
          @click="changeToAccountStatement(account.accountNumber)",
          style="cursor: pointer"
        )
          .caption.primary--text.ml-2 {{ account.accountName }}
          v-spacer
          f-account-balance-content(:account="account.accountNumber")
</template>
<script>
export default {
  name: "FInformationAccountCard",
  props: ["title", "listData"],
  data() {
    return {
      listAccount: [],
    };
  },
  mounted() {
    this.doInit(this.listData);
  },
  watch: {
    listData(val) {
      this.doInit(val);
    },
  },
  methods: {
    doInit(values) {
      this.listAccount = values || [];
    },
    changeToAccountStatement(accountNumber) {
      this.$router
        .push({
          name: "account-statement",
          params: { account: accountNumber, lastTransaction: true },
        })
        .catch((err) => {});
    },
  },
};
</script>